import { cached } from '@glimmer/tracking';
import type Transition from '@ember/routing/transition';
import config from 'uplisting-frontend/config/environment';
import BaseRoute from 'uplisting-frontend/pods/base/route';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { openPageWithAmplitudeDeviceId } from 'uplisting-frontend/utils/analytics';

export default class ProtectedRoute extends BaseRoute {
  @cached
  get currentUser(): ModelRegistry['user'] {
    return this.session.currentUser as ModelRegistry['user'];
  }

  async beforeModel(transition: Transition): Promise<void> {
    await super.beforeModel(transition);

    this.session.requireAuthentication(transition, () => {
      transition.abort();

      openPageWithAmplitudeDeviceId(config.auth.loginUrl);
    });

    const { onboardRoute } = this.currentUser;

    if (onboardRoute && transition.to?.name !== onboardRoute) {
      await this.router.transitionTo(onboardRoute);
    }
  }
}
